<template>
  <div class="stat-layout">
    <aside class="sidebar">
      <div class="filters">
        <button
          v-for="filter in filters"
          :key="filter.name"
          :class="{active: filter.enabled}"
          @click="toggle(filter)"
        >
          {{ filter.name }}
        </button>
        <button @click="selectAll">Tout sélectionner</button>
        <button @click="clearAll">Tout désélectionner</button>
      </div>
    </aside>
    <section class="graph-panel">
      <div class="slider">
        <label>
            Liens affichés à partir de
            <strong>{{ minJaccard }}%</strong>
        </label>
        <input
            type="range"
            min="0"
            max="100"
            step="1"
            style="--c: red;--l: 4px;"
            v-model="minJaccard"
            @input="refreshGraph"
        />
        <small>
          {{ displayedEdges }} liens affichés sur {{ stats?.edges.length ?? 0 }}
        </small>
      </div>
      <div ref="graph" class="graph"></div>
      <p class="info">Le pourcentage sur les liens donne le taux de discours qui, en mobilisant au moins une des deux dimension, mobilisent en réalité les deux</p>
    </section>
  </div>
</template>

<script>
import cytoscape from "cytoscape";
import fcose from "cytoscape-fcose";
import chatService from "@/services/chatService";

cytoscape.use(fcose);

export default {
  name: "StatWindow",
  data() {
    return {
      stats: null,
      minJaccard: 20,
      filters: [
        { name: "Racisme", enabled: true },
        { name: "Négationnisme", enabled: true },
        { name: "Déclin et renouveau", enabled: true },
        { name: "Validisme", enabled: true },
        { name: "Fragilité de genre", enabled: true },
        { name: "Agressivité", enabled: true },
        { name: "Soumission", enabled: true },
        { name: "Complotisme", enabled: true },
        { name: "Performance et libéralisme", enabled: true }
      ]
    }
  },
  async mounted(){
    this.stats = await chatService.getStats();
    this.createGraph(this.stats);
  },
  computed:{
    displayedEdges(){
        if(!this.stats){
            return 0;
        }
        return this.stats.edges.filter(
            e => e.jaccard >= this.minJaccard
        ).length;
    }
  },
  methods:{
    createGraph(stats){
      const elements = [];
      const enabled = this.filters.filter(f => f.enabled).map(f => f.name);
      stats.nodes.filter(node => enabled.includes(node.id)).forEach(node=>{
          elements.push({
              data:{
                  id: node.id,
                  label: node.id,
                  count: node.count
              }
          });
      });
      stats.edges.filter(edge =>
        enabled.includes(edge.source)
        &&
        enabled.includes(edge.target)
        &&
        edge.jaccard >= this.minJaccard
      ).forEach(edge=>{
          elements.push({
              data:{
                  source: edge.source,
                  target: edge.target,
                  weight: edge.count,
                  jaccard: edge.jaccard
              }
          });
      });
      this.cy = cytoscape({
        container:this.$refs.graph,
        elements,
        style:this.styles(),
        layout:{
            name:"fcose",
            animate:true,
            nodeRepulsion: node => {
                return 8000 * node.data("count");
            },
            quality: "proof",
            idealEdgeLength:250,
            edgeElasticity:0.2,
            gravity: 0.03,
            gravityRange: 5,
            fit: true,
        }
      });
    },
    styles(){
      return [
        {
          selector:"node",
          style:{
              label: ele =>ele.data("label") +"\n\n" +ele.data("count"),
              width: ele => 90 + Math.sqrt(ele.data("count"))*8,
              height: ele => 90 + Math.sqrt(ele.data("count"))*8,
              "background-color": ele => {
                const c = ele.data("count");
                if(c > 140) return "#ff2d2d";
                if(c > 100) return "#d62828";
                if(c > 70) return "#b91c1c";
                return "#7f1d1d";
              },
              "border-width": 3,
              "border-color": "darkRed",
              color: "white",
              color:"white",
              "font-size": ele =>20 + Math.sqrt(ele.data("count"))*0.5,
              "text-wrap":"wrap",
              "text-valign":"center",
              "text-halign":"center",
              "font-family": "Avenir",
              "text-wrap": "wrap",
              "text-valign": "center",
              "text-halign": "center",
          }
        },
        {
        selector:"edge",
        style:{
            width:5,
            label: ele => ele.data("jaccard").toFixed(0) + "%",
            "line-color": ele => {
              const j = ele.data("jaccard");
              if (j >= 90) return "#ff0000";
              if (j >= 75) return "#e10600";
              if (j >= 60) return "#c1121f";
              if (j >= 45) return "#a4161a";
              if (j >= 30) return "#800f2f";
              if (j >= 15) return "#5a0b1d";
              return "#2a0a0a";
            },
            opacity: ele => {
              const j = ele.data("jaccard");
              return 0.15 + (j / 100) * 0.85;
            },  
            color:"white",
            "font-size":16,
            "font-weight":"bold",
            "text-background-color":"#111315",
            "text-background-opacity":1,
            "text-background-padding":4,
            "text-border-width":1,
            "text-border-color":"#444",
            "text-rotation":"autorotate",
            "curve-style":"bezier"
          }
        }
      ];
    },
    toggle(filter) {
      filter.enabled = !filter.enabled;
      this.refreshGraph();
    },
    selectAll() {
      this.filters.forEach(f => f.enabled = true);
      this.refreshGraph();
    },

    clearAll() {
      this.filters.forEach(f => f.enabled = false);
      this.refreshGraph();
    },

    refreshGraph(){
      if(this.cy){
          this.cy.destroy();
      }
      this.createGraph(this.stats);
    },
  }
}
</script>

<style scoped>
.graph{
  width:100%;
  height: 100%;
  min-width:0;
  background:#111315;
  border-radius:20px;
}

.info{
  font-size: 10px;
  font-style: italic;
  font-weight: 500;
  color: #999;
  padding-bottom: 30px;
}
.filters{
  display:flex;
  flex-wrap:wrap;
  gap:8px;
}
.filters button{
  padding:10px 15px;
  border-radius:999px;
  border:1px solid #3b3b3b;
  background:#1d1f22;
  color:#8b8b8b;
  cursor:pointer;
  transition:.2s;
  font-weight:400;
  font-family: Avenir;
}

.filters button:hover{
  border-color:#b91c1c;
  color:white;
}

.filters button.active{
  background:#b91c1c;
  border-color:#b91c1c;
  color:white;
}

.slider{
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.slider label{
  display:block;
  margin-bottom:8px;
  color:#bdbdbd;
}

.slider small{
  color:#bdbdbd;
}

.slider input{
  width:100%;
}

.stat-layout{
    display:grid;
    grid-template-columns:260px 1fr;
    gap:25px;
    height:100%;
}

.sidebar{
  display:flex;
  flex-direction:column;
  gap:20px;
  width: 100%;

}

.filters{
  display:flex;
  flex-direction:column;
  gap:8px;
}

.filters button{
  width:100%;
  text-align:left;
}

.graph-panel{
    display:flex;
    flex-direction:column;
    flex:1;
    min-width:0;
    min-height:0;
}

input {
  --c: orange; /* active color */
  --g: 8px; /* the gap */
  --l: 5px; /* line thickness*/
  --s: 20px; /* thumb size*/
  width: 200px;
  height: var(--s); /* needed for Firefox*/
  --_c: color-mix(in srgb, var(--c), #000 var(--p,0%));
  -webkit-appearance :none;
  -moz-appearance :none;
  appearance :none;
  background: none;
  cursor: pointer;
  overflow: hidden;
}
input:focus-visible,
input:hover{
  --p: 25%;
}
input:active,
input:focus-visible{
  --_b: var(--s)
}
/* chromium */
input[type="range" i]::-webkit-slider-thumb{
  height: var(--s);
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: 0 0 0 var(--_b,var(--l)) inset var(--_c);
  border-image: linear-gradient(90deg,var(--_c) 50%,#ababab 0) 0 1/calc(50% - var(--l)/2) 100vw/0 calc(100vw + var(--g));
  -webkit-appearance: none;
  appearance: none;
  transition: .3s;
}
/* Firefox */
input[type="range"]::-moz-range-thumb {
  height: var(--s);
  width: var(--s);
  background: none;
  border-radius: 50%;
  box-shadow: 0 0 0 var(--_b,var(--l)) inset var(--_c);
  border-image: linear-gradient(90deg,var(--_c) 50%,#ababab 0) 0 1/calc(50% - var(--l)/2) 100vw/0 calc(100vw + var(--g));
  -moz-appearance: none;
  appearance: none;
  transition: .3s;
}
@supports not (color: color-mix(in srgb,red,red)) {
  input {
    --_c: var(--c);
  }
}

</style>